import React from 'react';
import { v4 as uuid } from 'uuid';
import { Helmet } from 'react-helmet';

import { makeStyles } from '@material-ui/core/styles';

import Header from './Header';
import Features from './Features';
import Destructured from './Destructured';
import TechSpecs from './TechSpecs';
import I18n from '../I18n';

const featuresInfo = [
	{
		flexDirection: 'row-reverse',
		text: [`${I18n('CB11.highlight_1')}`,`${I18n('CB11.highlight_1_1')}`],
		imgSrc: '/CB11/CB11PatchAdhesive.png',
		imgAlt: 'CB11 patch monitor'
	},
	{
		flexDirection: 'row',
		text: [`${I18n('CB11.highlight_2')}`],
		imgSrc: '/CB11/CB11patchOnChest.svg',
		imgAlt: 'CB11 patch on chest'
	},
	{
		flexDirection: 'row-reverse',
		text: [`${I18n('CB11.highlight_3')}`],
		imgSrc: '/devices/pixel_ECG_port.png',
		imgAlt: 'pixel phone showing ECG'
	}
];

const specInfo = [
  {
    title: `${I18n('CB11.dimension')}`,
    detail: `${I18n('CB11.dimension_value')}`
  },
  {
    title: `${I18n('CB11.weight')}`,
    detail: `${I18n('CB11.weight_value')}`
  },
  {
    title: `${I18n('CB11.range')}`,
    detail: `${I18n('CB11.rang_value')}`
  },
  {
    title: `${I18n('CB11.input')}`,
    detail: `${I18n('CB11.input_value')}`
  },
  {
    title: `${I18n('CB11.frequency')}`,
    detail: `${I18n('CB11.frequency_value')}`
  },
  {
    title: `${I18n('CB11.rate')}`,
    detail: `${I18n('CB11.rate_value')}`
  },
  {
    title: `${I18n('CB11.battery_type')}`,
    detail: `${I18n('CB11.battery_type_value')}`
  },
  {
    title: `${I18n('CB11.connect')}`,
    detail: `${I18n('CB11.connect_value')}`
  }
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  }
}));

const CB11Patch = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Helmet>
        <title>CB11 Patch ECG Monitor </title>
        <meta
          name='description'
          content='Wearable ECG sensor. Medical grade long-term cardiac monitoring. Up to 15 days of continuous mobile cardiac telemetry.'
        />
      </Helmet>
      <Header />
      {featuresInfo.map((info) => (
        <Features key={uuid()} {...info} />
      ))}
      <Destructured />
      <TechSpecs
        title={I18n('CB11.specification')}
        specInfo={specInfo}
      />
    </div>
  );
};

export default CB11Patch;
